import useMediaQuery from "@mui/material/useMediaQuery";

const useMobileView = () => {
  return useMediaQuery("(max-width:599.95px)");
};

export default useMobileView;
